import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Quayside',
    legalName: 'Quayside Ltd',
    tagline: 'Every port connected. Every box accounted for.',
    description: 'Quayside connects carriers, ports, customs brokers, warehouses and ERPs into one live freight flow, and a human operations team handles the exceptions.',
    url: getOrigin()
}
